import GetCompanyFeedbacksRequestModelBase from '../_generated/modelBases/get-company-feedbacks-request-model-base';

export default class GetCompanyFeedbacksRequestModel extends GetCompanyFeedbacksRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
